module.exports = __webpack_public_path__ + "static/media/paladin.29ac2bd5.png";